// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    CartLineModel,
    ConfigSectionModel,
    ProductModel,
    WishListLineModel,
} from "@insite/client-framework/Types/ApiModels";
import { KitProductInfo } from "@store/Framework/Types/KitProductInfo";

export const hasKitConfiguration = (productInfo: KitProductInfo): boolean => {
    const selection = productInfo.kitConfiguration;
    if (!selection) {
        return false;
    }

    return Array.isArray(selection)
        ? selection.some(optionId => !!optionId)
        : Object.values(selection).some(optionId => !!optionId);
};

export const parseKitConfiguration = (wishListLine: WishListLineModel): SafeDictionary<string> | undefined => {
    const raw = wishListLine.properties?.["kitConfiguration"];
    if (!raw) {
        return undefined;
    }

    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? (parsed as SafeDictionary<string>) : undefined;
    } catch {
        // A malformed value must not stop the line rendering; the kit is simply added unconfigured.
        return undefined;
    }
};

export const getKitConfigurationOptionIds = (wishListLine: WishListLineModel): string[] | undefined => {
    const selection = parseKitConfiguration(wishListLine);
    if (!selection) {
        return undefined;
    }

    const optionIds = Object.values(selection).filter((optionId): optionId is string => !!optionId);

    return optionIds.length > 0 ? optionIds : undefined;
};
export const isProductKit = (product: ProductModel): boolean => {
    const configuration = product.detail?.configuration;
    const kitConfiguration = product.properties.kitConfiguration;
    const kitConfigurationSummary = product.properties.kitConfigurationSummary;

    return (
        (!!configuration && configuration.isKit === false && (configuration.configSections?.length ?? 0) > 0) ||
        (Boolean(kitConfiguration) && Boolean(kitConfigurationSummary))
    );
};

export const isProductKitCartLine = (line: Pick<CartLineModel, "isConfigured" | "isFixedConfiguration">) =>
    line.isConfigured && !line.isFixedConfiguration;

export type KitSelectionState = "none" | "partial" | "full";

export const getKitSelectionState = (
    configSections: ConfigSectionModel[] | null | undefined,
    configurationSelection: SafeDictionary<string> | undefined,
): KitSelectionState => {
    const sectionIds = configSections?.map(section => section.id) ?? [];
    if (sectionIds.length === 0) {
        return "full";
    }

    const selectedCount = sectionIds.filter(id => !!configurationSelection?.[id]).length;
    if (selectedCount === 0) {
        return "none";
    }
    return selectedCount === sectionIds.length ? "full" : "partial";
};
